var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApprove = function SvgApprove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m11.5 2.97-1.6-1.6c-.5-.5-1.3-.5-1.8 0l-1.6 1.6H4.25c-.7 0-1.28.57-1.28 1.28V6.5l-1.6 1.6c-.5.5-.5 1.3 0 1.8l1.6 1.6v2.25c0 .7.57 1.28 1.28 1.28H6.5l1.6 1.6c.5.5 1.3.5 1.8 0l1.6-1.6h2.25c.7 0 1.28-.57 1.28-1.28V11.5l1.6-1.6c.5-.5.5-1.3 0-1.8l-1.6-1.6V4.25c0-.7-.57-1.28-1.28-1.28H11.5v0Z",
    clipRule: "evenodd",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m11 8-2.4 3L7 9.74",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgApprove;